module.exports = __webpack_public_path__ + "download_googleplay_pr.svg?2f874abb74ebdf3239fe5be3dacf13c9";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/download_googleplay_pr.svg
// module id = 1060
// module chunks = 15